import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeEvery } from "redux-saga/effects";
import { loadStripeProductsError, loadStripeProductsSuccess } from "./slice";
import { LOAD_STRIPE_PRODUCTS_ACTION } from "./actionTypes";
import { retrieveStripeProducts } from "../../service/common/stripe";

function* loadStripeProducts({
  payload: _
}: PayloadAction<undefined>): any {
  try {
    const stripeProducts = yield call(retrieveStripeProducts);
    console.log(stripeProducts);
    yield put(loadStripeProductsSuccess(stripeProducts));
  } catch (error) {
    yield put(loadStripeProductsError(error));
  }
}

export default function* stripeSaga() {
  yield takeEvery(LOAD_STRIPE_PRODUCTS_ACTION, loadStripeProducts);
}